"use strict";

module.exports = {
  'name': 'LOG2E',
  'category': 'Constants',
  'syntax': ['LOG2E'],
  'description': 'Returns the base-2 logarithm of E, approximately equal to 1.442',
  'examples': ['LOG2E', 'log(e, 2)'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/constants/LOG2E.js
// module id = 789
// module chunks = 0